module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "sample-text-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v("Text Sample")]), _vm._v(" "), _c('p', {
    staticClass: "sample-text"
  }, [_vm._v("\n        Every avid independent filmmaker has "), _c('b', [_vm._v("Bold")]), _vm._v(" about making that "), _c('i', [_vm._v("Italic")]), _vm._v(" interest documentary, or short film to show off their creative prowess. Many have great ideas and want to “wow” the"), _c('sup', [_vm._v("Superscript")]), _vm._v(" scene, or video renters with their big project.  But once you have the"), _c('sub', [_vm._v("Subscript")]), _vm._v(" “in the can” (no easy feat), how do you move from a "), _c('del', [_vm._v("Strike")]), _vm._v(" through of master DVDs with the "), _c('u', [_vm._v("“Underline”")]), _vm._v(" marked hand-written title inside a secondhand CD case, to a pile of cardboard boxes full of shiny new, retail-ready DVDs, with UPC barcodes and polywrap sitting on your doorstep?  You need to create eye-popping artwork and have your project replicated. Using a reputable full service DVD Replication company like PacificDisc, Inc. to partner with is certainly a helpful option to ensure a professional end result, but to help with your DVD replication project, here are 4 easy steps to follow for good DVD replication results:\n\n      ")])])]), _vm._v(" "), _c('section', {
    staticClass: "button-area"
  }, [_c('div', {
    staticClass: "container border-top-generic"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v("Sample Buttons")]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area"
  }, [_c('a', {
    staticClass: "genric-btn default",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn primary e-large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Extra Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary small",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Small")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn primary-border e-large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Extra Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border small",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Small")])])])]), _vm._v(" "), _c('div', {
    staticClass: "whole-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Left Aligned")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 mt-sm-20 left-align-p"
  }, [_c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players found themselves being chased by the Federal government. But, after a fortnight, the online casino industry came up with a solution and new online casinos started taking root. These began to operate under a different business umbrella, and by doing that, rendered the transfer of money to and from them legal. A major part of this was enlisting electronic banking systems that would accept this new clarification and start doing business with me. Listed in this article are the electronic banking systems that accept players from the United States that wish to play in online casinos.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border text-right"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Right Aligned")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('p', {
    staticClass: "text-right"
  }, [_vm._v("Over time, even the most sophisticated, memory packed computer can begin to run slow if we don’t do something to prevent it. The reason why has less to do with how computers are made and how they age and more to do with the way we use them. You see, all of the daily tasks that we do on our PC from running programs to downloading and deleting software can make our computer sluggish. To keep this from happening, you need to understand the reasons why your PC is getting slower and do something to keep your PC running at its best. You can do this through regular maintenance and PC performance optimization programs")]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("Before we discuss all of the things that could be affecting your PC’s performance, let’s talk a little about what symptoms")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.jpg",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Definition")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 01")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 02")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 03")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Block Quotes")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('blockquote', {
    staticClass: "generic-blockquote"
  }, [_vm._v("\n              “Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players found themselves being chased by the Federal government. But, after a fortnight, the online casino industry came up with a solution and new online casinos started taking root. These began to operate under a different business umbrella, and by doing that, rendered the transfer of money to and from them legal. A major part of this was enlisting electronic banking systems that would accept this new clarification and start doing business with me. Listed in this article are the electronic banking”\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Table")]), _vm._v(" "), _c('div', {
    staticClass: "progress-table-wrap"
  }, [_c('div', {
    staticClass: "progress-table"
  }, [_c('div', {
    staticClass: "table-head"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("#")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_vm._v("Countries")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("Visits")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_vm._v("Percentages")])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f1.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "80",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f2.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-2",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "30",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f3.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-3",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "55",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("04")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f4.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-4",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("05")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f5.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-5",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "40",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("06")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f6.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-6",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "70",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("07")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f7.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-7",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "30",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("08")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f8.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-8",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "title_color"
  }, [_vm._v("Image Gallery")]), _vm._v(" "), _c('div', {
    staticClass: "row gallery-item"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g1.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g1.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g2.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g2.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g3.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g3.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g4.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g4.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g5.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g5.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g6.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g6.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g7.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g7.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g8.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g8.jpg)"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-sm-6 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Typography")]), _vm._v(" "), _c('div', {
    staticClass: "typography"
  }, [_c('h1', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")]), _vm._v(" "), _c('h2', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 02")]), _vm._v(" "), _c('h3', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 03")]), _vm._v(" "), _c('h4', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 04")]), _vm._v(" "), _c('h5', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")]), _vm._v(" "), _c('h6', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-6 mt-sm-30 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Unordered List")]), _vm._v(" "), _c('div', {}, [_c('ul', {
    staticClass: "unordered-list"
  }, [_c('li', [_vm._v("Fta Keys")]), _vm._v(" "), _c('li', [_vm._v("For Women Only Your Computer Usage")]), _vm._v(" "), _c('li', [_vm._v("Facts Why Inkjet Printing Is Very Appealing\n                  "), _c('ul', [_c('li', [_vm._v("Addiction When Gambling Becomes\n                      "), _c('ul', [_c('li', [_vm._v("Protective Preventative Maintenance")])])])])]), _vm._v(" "), _c('li', [_vm._v("Dealing With Technical Support 10 Useful Tips")]), _vm._v(" "), _c('li', [_vm._v("Make Myspace Your Best Designed Space")]), _vm._v(" "), _c('li', [_vm._v("Cleaning And Organizing Your Computer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-6 mt-sm-30 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Ordered List")]), _vm._v(" "), _c('div', {}, [_c('ol', {
    staticClass: "ordered-list"
  }, [_c('li', [_c('span', [_vm._v("Fta Keys")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("For Women Only Your Computer Usage")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Facts Why Inkjet Printing Is Very Appealing")]), _vm._v(" "), _c('ol', {
    staticClass: "ordered-list-alpha"
  }, [_c('li', [_c('span', [_vm._v("Addiction When Gambling Becomes")]), _vm._v(" "), _c('ol', {
    staticClass: "ordered-list-roman"
  }, [_c('li', [_c('span', [_vm._v("Protective Preventative Maintenance")])])])])])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Dealing With Technical Support 10 Useful Tips")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Make Myspace Your Best Designed Space")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Cleaning And Organizing Your Computer")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Form Element")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "First Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'First Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "last_name",
      "placeholder": "Last Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Last Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "last_name",
      "placeholder": "Last Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Last Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "email",
      "name": "EMAIL",
      "placeholder": "Email address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Email address'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "address",
      "placeholder": "Address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Address'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plane",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-select",
    attrs: {
      "id": "default-select"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Dhaka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Dilli")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Newyork")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Islamabad")])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-select",
    attrs: {
      "id": "default-select2"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bangladesh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("India")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("England")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Srilanka")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('textarea', {
    staticClass: "single-textarea",
    attrs: {
      "placeholder": "Message",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Message'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-primary",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Primary color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Primary color'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-accent",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Accent color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Accent color'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-secondary",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Secondary color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Secondary color'",
      "required": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-4 mt-sm-30 element-wrap"
  }, [_c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Switches")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample Switch")]), _vm._v(" "), _c('div', {
    staticClass: "primary-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-switch"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-switch"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color Switch")]), _vm._v(" "), _c('div', {
    staticClass: "primary-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-switch",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-switch"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color Switch")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-switch",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-switch"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Selectboxes")]), _vm._v(" "), _c('div', {
    staticClass: "default-select",
    attrs: {
      "id": "default-select"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Arabic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Portuguise")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bengali")])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Checkboxes")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "primary-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "primary-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("04. Disabled Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("05. Disabled Checkbox active")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-checkbox-active",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-checkbox-active"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Radios")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample radio")]), _vm._v(" "), _c('div', {
    staticClass: "primary-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-radio"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color radio")]), _vm._v(" "), _c('div', {
    staticClass: "primary-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color radio")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("04. Disabled radio")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-radio",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("05. Disabled radio active")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-radio-active",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-radio-active"
    }
  })])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7efeb34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Elements.vue
// module id = 299
// module chunks = 1